<template lang="html">
  <div>
    <div class="footer-top"  v-if="survey[$route.params.survey]">
      <div class="footer-col-2">
        <div class="footer-col">
          <h6>Falck Sikkerhedstjek</h6>
        </div>
        <div class="footer-col">
          {{survey[$route.params.survey].content5}}
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-col-2">
        <div class="footer-col">
          <h6>Kontakt</h6>
          <a href="mailto:kundeservice@falck.dk">kundeservice@falck.dk</a>
        </div>
        <div class="footer-col">
          <div class="footer-col-content">
            Falck<br>
            Sydhavnsgade 18<br>
            2450 København SV<br>
            CVR 38049372
          </div> 
          <div class="footer-col-links">
            <ul>
              <li><a target="_blank" href="https://www.falck.dk/om-falck/kontakt/cookies/cookie-og-persondatapolitik/">Cookie- og persondatapolitik</a></li>
              <li><a target="_blank" href="http://mb.falck.com/?kode=0005,0002&privat=true&erhverv=true&D=1">Generelle vilkår og handelsbetingelser</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
  name: 'CFooter',
  computed: {
    ...mapGetters([
      'survey'
    ])
  },
  methods:{

  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/modular/cfooter.vue